//export const API_HOST = "https://chkoluevano.dev:3000"; //SERVER PRUEBAS
//export const SUB_DIR = "parque/"; //SERVER PRUEBAS parque/

export const API_HOST = "https://miparquemetroleon.com:3000"; //PRODUCCION
export const SUB_DIR = ""; //PRODUCCION  
export const API_PETS = "https://api.kodering.com";
export const TOKEN = "token";